import axios from "@/axios";

const apiRoutes = {
  workAllocationMatrix: "/wam/",
}

const api = {
  getWorkAllocationMatrixList: async () => {
    try {
      const response = await axios.get(apiRoutes.workAllocationMatrix);
      return response.data;
    } catch (error) {
      console.error("Error fetching work allocation matrix:", error);
      throw error;
    }
  },
  getWorkAllocationMatrixItem: async (id) => {
    try {
      const response = await axios.get(apiRoutes.workAllocationMatrix, {
        params: { wam_id: id },
      });
      const { data } = response.data;
      return data?.[0] || null; // Return the first item or null if not found
    } catch (error) {
      console.error(`Error fetching work allocation matrix with ID ${id}:`, error);
      throw error;
    }
  },
  postWorkAllocationMatrixItem: async (payload) => {
    try {
      const response = await axios.post(apiRoutes.workAllocationMatrix, payload);
      return response.data;
    } catch (error) {
      console.error(`Error creating work allocation matrix:`, error);
      throw error;
    }
  },
  putWorkAllocationMatrixItem: async (id, payload) => {
    try {
      const response = await axios.put(`${apiRoutes.workAllocationMatrix}${id}/`, payload);
      return response.data;
    } catch (error) {
      console.error(`Error updating work allocation matrix with ID ${id}:`, error);
      throw error;
    }
  },
  deleteWorkAllocationMatrixItem: async (id) => {
    try {
      const response = await axios.delete(`${apiRoutes.workAllocationMatrix}${id}/`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting work allocation matrix with ID ${id}:`, error);
      throw error;
    }
  },
  cloneWorkAllocationMatrixItem: async (id, payload) => {
    try {
      const response = await axios.post(`${apiRoutes.workAllocationMatrix}${id}/clone/`, payload);
      return response.data;
    } catch (error) {
      console.error(`Error cloning work allocation matrix with ID ${id}:`, error);
      throw error;
    }
  },
  // TODO clone
}

export default api;